export class SetSubscriptionStateFromUserLogin {
  static readonly type = '[Subscription] Set Subscription Details from User Login';
}

export class SetSubscriptionStateUpgradeSubscription {
  static readonly type = '[Subscription] Set Subscription From Upgrade Subscription';
}

export class SetSubscriptionStateFromReloadAppState {
  static readonly type = '[Subscription] Set Subscription State From Reload AppState';
}

export class ClearSubscriptionState {
  static readonly type = '[Subscription] Clear Subscription State';
}
